<template>
    <span v-show="false"></span>
</template>
<script>
import store from '../store'
import _ from 'lodash'
import Vue from 'vue'

export default {
  name: 'InitialData',
  data () {
    return { ...window.vueData.initialData }
  },
  mounted () {
    if (this.hasOwnProperty('allAttributes')) {
      store.dispatch('setAllAttributes', this.allAttributes)
    }

    if (this.hasOwnProperty('cartData')) {
      store.dispatch('setCartData', this.cartData)
    }

    if (this.hasOwnProperty('productBadges')) {
      store.dispatch('setProductBadges', this.productBadges)
    }

    if (this.hasOwnProperty('config')) {
      store.dispatch('setConfig', this.config)
    }

    if (this.hasOwnProperty('products')) {
      store.dispatch('setLiveProducts', this.products)
    }

    if (this.hasOwnProperty('selectedProductCodeId')) {
      store.dispatch('setSelectedProductCodeId', this.selectedProductCodeId)
    }
  },
  methods: {
    checkConnectionStatus () {
      store.dispatch('setOnlineStatus', navigator.onLine)
    }
  },
  created () {
    this.checkConnectionStatus()
    window.addEventListener('offline', this.checkConnectionStatus)
    window.addEventListener('online', this.checkConnectionStatus)
  },
  destroyed () {
    window.removeEventListener('offline', this.checkConnectionStatus)
    window.removeEventListener('online', this.checkConnectionStatus)
  }
}
</script>
